import AIOInput, { AITabs, AITYPE } from "aio-input";
import AIOTable, { I_table_column } from "aio-table";
import usePopup, { I_usePopup } from "aio-popup";
import { FC, ReactNode, useEffect, useRef, useState } from "react";
import AIOApis from 'aio-apis';
import './index.css';
import Icon from "@mdi/react";
import { mdiReorderHorizontal } from "@mdi/js";
type I_tables_config = {
    [tableId: string]: {
        tableConfig: I_table_config,
        tableName: string
    }
}
type I_table_config = { [field: string]: I_config }
type I_table = { [key in string]: I_row[] }
type I_tables_dic = { [tableId: string]: I_table };
type I_filter = (item: I_row) => boolean;
type I_items_dic = { [key: string]: any[] }
type I_input = AITYPE & { def: any, field: string, width: number, setProps?: (row: I_row) => { [key in keyof AITYPE]?: any } }
type I_row = { text: string, id: string, model: { [key: string]: any } }
type I_config = {
    idField: string, textField: string, tabText: string, inputs: I_input[], getDefaultModel: (row: I_row) => { [key: string]: any }, filter?: I_filter,
    onChange?: (newRows: I_row[]) => boolean
}
type I_BCCRender = { tableId: string, onClose?: () => void, items_dic: I_items_dic }
type I_BCC = {
    onLoad: () => void,
    config_dic: I_tables_config,
    token: string,
    base_url: string,
    userId:number
}
class BCC {
    bcc: I_BCC;
    apis: APIS;
    popup?: I_usePopup;
    tables_dic?: I_tables_dic;
    constructor(bcc: I_BCC) {
        this.bcc = bcc;
        this.apis = new APIS(bcc);
        this.fetchData()
    }
    resetTable = async (tableId: any) => {
        const tableName = this.bcc.config_dic[tableId].tableName
        this.popup.addConfirm({
            setAttrs: (key) => {
                return { className: `bcc-${key}` }
            },
            title: `بازنشانی`,
            text:`آیا از بازنشانی تنظیمات شضصی سازی اطمینان دارید ؟ پس از بازنشانی تنظیمات شخصی سازی بخش ${tableName} حذف می شود`,
            onSubmit: async () => {
                const res = await this.apis.updateData({ ...this.tables_dic, [tableId]: {} });
                if (res) { window.location.reload(); return true }
                return false
            }

        })
    }
    fetchData = async () => {
        this.tables_dic = await this.apis.getData()
        this.bcc.onLoad()
    }
    getDefaultTable = (tableId: string, items_dic: I_items_dic): I_table => {
        let res: I_table = {};
        for (let field in this.bcc.config_dic[tableId].tableConfig) { res[field] = this.getDefaultRows(tableId, field, items_dic[field]) }
        return res
    }
    getDefaultRows = (tableId: string, field: string, items: any[]): I_row[] => {
        const tableData: I_table = this.tables_dic[tableId] || {}
        let rows = tableData[field];
        if (!rows) {
            const config = this.bcc.config_dic[tableId].tableConfig[field]
            rows = items.map((o): I_row => ({ id: o[config.idField], text: o[config.textField], model: config.getDefaultModel(o) }))
        }
        return rows
    }
    render = (p: I_BCCRender): ReactNode => {
        const { tableId, items_dic } = p;
        if (!this.tables_dic) { return null }
        const tableData: I_table = this.getDefaultTable(tableId, items_dic)
        return (
            <BCCPart
                key={tableId} resetTable={() => this.resetTable(tableId)} table_config={this.bcc.config_dic[tableId].tableConfig} tableData={tableData}
                apis={this.apis}
                showAlert={this.showAlert}
                items_dic={items_dic}
                onSubmit={async (newData) => {
                    const newDataDic: I_tables_dic = { ...this.tables_dic, [tableId]: newData }
                    const res = await this.apis.updateData(newDataDic);
                    if (res) { window.location.reload() }
                }}
            />
        )
    }
    openModal = (param: I_BCCRender) => {
        const tableName = this.bcc.config_dic[param.tableId].tableName
        if (!this.popup) { return null }
        this.popup.addModal({
            position: 'center', header: { title: 'سفارشی سازی', subtitle: tableName }, body: this.render(param),
            setAttrs: (key) => {
                if (key === 'modal') { return { style: { width: '90vw', height: '90vh', borderRadius: 12, overflow: 'hidden' } } }
                if (key === 'header') { return { style: { height: 60, padding: '0 24px', alignItems: 'center' } } }
                if (key === 'backdrop') { return { style: { background: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(2px)' } } }
            }
        })
    }
    showAlert = (text: string) => this.popup.addSnackebar({ type: 'warning', text })
    renderModal = (): ReactNode => {
        return (
            <RenderModal
                setPopup={(popup) => this.popup = popup}
            />
        )
    }
    getCustomItemsByOriginalItems = (param: { tableId: string, field: string, mainItems: any[], filter?: I_filter }): any[] => {
        const { tableId, field, mainItems } = param;
        const config: I_config = this.bcc.config_dic[tableId].tableConfig[field];
        const { idField, getDefaultModel } = config;
        const filter: (I_filter | undefined) = param.filter || config.filter;
        let rows: I_row[] = [];
        if (!this.tables_dic || !this.tables_dic[tableId] || !this.tables_dic[tableId][field]) {
            rows = mainItems.map((o) => ({ id: o[idField], model: getDefaultModel(o), text: '' }))
        }
        else { rows = this.tables_dic[tableId][field] }
        let res: any[] = [], dic: { [id: string]: any } = {}
        for (let mc of mainItems) { dic[mc[idField]] = mc; }
        for (let cc of rows) {
            if (!dic[cc.id]) { continue }
            if (filter && !filter(cc)) { dic[cc.id] = undefined; continue }
            res.push(dic[cc.id]);
            dic[cc.id] = undefined
        }
        const otherColumnsIds = Object.keys(dic)
        for (let id of otherColumnsIds) { if (dic[id]) { res.push(dic[id]); } }
        return res
    }
}
export default BCC
const RenderModal: FC<{ setPopup: (popup: I_usePopup) => void }> = ({ setPopup }) => {
    const popup = usePopup();
    useEffect(() => {
        setPopup(popup)
    }, [])
    return popup.render()
}
type I_BCCPart = { resetTable: () => void, apis: APIS, table_config: I_table_config, tableData: I_table, onSubmit: (v: I_table) => void, showAlert: (text: string) => void, items_dic: I_items_dic }
const BCCPart: FC<I_BCCPart> = ({ resetTable, tableData, table_config, onSubmit, showAlert, items_dic }) => {
    debugger
    const fields: string[] = Object.keys(table_config);
    console.log(fields)
    const [tab, setTab] = useState<string>(fields[0])
    const [rows_dic, setRows_dic] = useState<I_table>(getRows_dic)
    function getRows_dic(): I_table {
        let res: any = {};
        for (let field of fields) { res[field] = getInitialRows(field) }
        return res
    }
    const rowsRef = useRef(rows_dic);
    rowsRef.current = rows_dic;
    function getInitialRows(tab: string): I_row[] {
        const tabData = tableData[tab];
        let res: I_row[] = []
        let dic: { [mainColumnId: string]: string | undefined } = {}
        const config: I_config = table_config[tab];
        const { idField, textField } = config;
        for (let item of items_dic[tab]) { dic[item[idField]] = item[textField]; }
        for (let dataItem of tabData) {
            if (!dic[dataItem.id]) { continue }
            res.push({ ...dataItem });
            dic[dataItem.id] = undefined
        }
        const otherColumnsIds = Object.keys(dic)
        for (let id of otherColumnsIds) {
            const text = dic[id]
            if (text === undefined) { continue }
            res.push({ text, id, model: {} });
        }
        return res
    }
    const options = fields.map((field: string) => ({ text: table_config[field].tabText, value: field }))
    function changeRows_dic(v: any[]) {
        const newRows_dic = { ...rowsRef.current, [tab]: v };
        rowsRef.current = newRows_dic
        setRows_dic(newRows_dic)
    }
    function tabs_layout() {
        return (
            <AITabs
                options={options} value={tab}
                onChange={(tab) => setTab(tab)}
                after={(
                    <div className='bcc-tab-after'>
                        <button onClick={() => resetTable()}>بازنشانی تنظیمات</button>
                        <button className='active' onClick={() => onSubmit(rows_dic)}>ذخیره</button>
                    </div>
                )}
            />
        )
    }
    return (
        <div className="bcc">
            {tabs_layout()}
            <BCCTable
                key={tab} rows={rowsRef.current[tab]} onChange={(v) => changeRows_dic(v)}
                config={table_config[tab]} showAlert={showAlert}
            />
        </div>
    )
}
type I_BCCTable = { rows: any[], onChange: (v: any[]) => void, config: I_config, showAlert: (text: string) => void }
const BCCTable: FC<I_BCCTable> = ({ rows, onChange, config, showAlert }) => {
    const rowsRef = useRef(rows);
    rowsRef.current = rows;
    const [columns] = useState<I_table_column<any>[]>(getColumns)
    function getColumns() {
        let res: I_table_column<any>[] = [
            { width: 12 },
            { template: () => <Icon path={mdiReorderHorizontal} size={1} color={'#ef5644'} />, width: 30,justify:true },
            { value: 'row.text', search: true }
        ]
        for (let i = 0; i < config.inputs.length; i++) {
            const input = config.inputs[i];
            const { field, width = 200, setProps = () => ({}), def } = input;
            res.push({
                width,
                template: ({ row }) => {
                    let value = row.model[field];
                    value = value === undefined ? def : value
                    const customProps = setProps(row)
                    return (
                        <AIOInput
                            {...input}
                            value={value}
                            onChange={(newValue) => {
                                const newRows: I_row[] = rowsRef.current.map((o: I_row): I_row => o.id !== row.id ? o : { ...o, model: { ...o.model, [field]: newValue } })
                                if (config.onChange) {
                                    const res = config.onChange(newRows)
                                    if (res === false) { return }
                                }
                                onChange(newRows)
                            }}
                            {...customProps}
                        />
                    )
                }
            })
        }
        return res
    }
    return (<AIOTable columns={columns} onSearch={true} headerAttrs={{ style: { display: 'none' } }} onSwap={true} value={rows} onChange={(rows) => onChange(rows)} />)
}
class APIS extends AIOApis {
    p: I_BCC
    constructor(p: I_BCC) {
        super({
            id: 'boxitapbcc', lang: 'fa', token: p.token,
            handleErrorMessage: () => {
                return 'خطا'
            }
        })
        this.p = p
    }
    getData = async () => {
        const { success, response } = await this.request<{data:{status:any,payload:{customize:string}}}>({
            name:'getData',
            description: 'دریافت دیتای شخصی سازی',
            method: 'get',
            url: `${this.p.base_url}/resource-api/customize/${this.p.userId}`,
            loading: false
        })
        if (success) {
            if (response.data.status === 'OK') {
                const customize = response.data.payload.customize;
                const res:I_tables_dic = typeof customize !== 'string' ? {} : JSON.parse(customize)
                return res
            }
        }
        return {}
    }
    updateData = async (newData: I_tables_dic): Promise<boolean> => {
        const { response, success } = await this.request<{data:{status:any}}>({
            name:'updateData',
            description: 'ویرایش دیتای شخصی سازی', method: 'post', 
            url: `${this.p.base_url}/resource-api/customize`,
            loading: false,
            body: { userId:this.p.userId, customize: JSON.stringify(newData) },
        })
        if(!success){return false}
        return response.data.status === 'OK'
    }
}